import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const openId = uni.getStorageSync('openId');

const store = new Vuex.Store({
	
	state: {
		openId: openId || ''
	},
	
	mutations: {
		// 设置城市
		setOpenId(state, val) {
			state.openId = val
			uni.setStorageSync('openId', val);
		}
	}
	
})

export default store;